import { render } from "./Root.vue?vue&type=template&id=7c167b3b&scoped=true"
import script from "./Root.vue?vue&type=script&lang=js"
export * from "./Root.vue?vue&type=script&lang=js"

import "./Root.vue?vue&type=style&index=0&id=7c167b3b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7c167b3b"

export default script